import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const BodyPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding-inline: 16px;
  padding-bottom: 24px;
`;

export const CardBodyContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 16px;
  width: 100%;
`;

export const FullWidthField = styled.div`
  grid-column: 1 / -1;
`;

export const HelperText = styled.p`
  color: ${Colors.text_Color_1};
  font-size: 0.7em;
  font-weight: 300;
  margin-top: 4px;
`;

export const RadiosContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RadioLabel = styled.p`
  color: ${Colors.text_Color_1};
  font-size: 0.8em;
  font-weight: 500;
`;

export const RadioContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
`;

export const DocumentosContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DocumentoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LinkButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 38px;
  width: 38px;
  flex-shrink: 0;

  border: 1px solid rgb(255 255 255 / 0.15);
  border-radius: 8px;
  color: ${Colors.text_Color_1};

  transition: background 300ms ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  background: transparent;
  border: none;
  border-radius: 4px;

  height: 38px;
  width: 38px;
  flex-shrink: 0;
  cursor: pointer;

  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: background, border;

  &:hover {
    background: #ffffff10;
    border: 1px solid #ffffff25;
  }
`;
